// extracted by mini-css-extract-plugin
export default {"comment":"comment--eTZ1k","modal":"modal--II0R3","fullSizeImage":"fullSizeImage--Bk4Pk","closeButton":"closeButton--QvWWq"};